import { Modal } from 'bootstrap';

class GalleryModal {
    constructor() {
        console.log('GalleryModal constructor called');

        const ID = {
            modalContainer: 'galleryModal',
            modalImage: 'gallery-modal-image'
        }
        
        const modalEl = document?.getElementById(ID.modalContainer);
        const modalImage = document?.getElementById(ID.modalImage);

        console.log('Modal elements found:', {
            modalEl: !!modalEl,
            modalImage: !!modalImage
        });

        const init = () => {
            if (modalEl) {
                console.log('Initializing modal');
                const modal = new Modal(modalEl, {
                    backdrop: true,
                    keyboard: true,
                    focus: true
                });

                // Add hide event listener to cleanup
                modalEl.addEventListener('hidden.bs.modal', () => {
                    // Remove modal-open class from body if menu isn't open
                    const menuToggle = document.getElementById('main-nav');
                    if (!menuToggle?.classList.contains('active')) {
                        document.body.classList.remove('overflow-hidden');
                    }
                });

                modalEl.addEventListener('show.bs.modal', (event) => {
                    console.log('Modal show event triggered');
                    const button = event.relatedTarget;
                    console.log('Button clicked:', button);
                    
                    if (button && modalImage) {
                        const fullImage = button.getAttribute('data-full-image');
                        const imageAlt = button.getAttribute('data-image-alt');
                        
                        console.log('Setting image:', { fullImage, imageAlt });
                        modalImage.src = fullImage;
                        modalImage.alt = imageAlt || '';
                    }
                });
            }
        }

        init();
    }
}

export default GalleryModal; 